<ng-template #appTitleTemplate>
  <!--<div class="small">
    <h2>
      Log in to <span class="app-title">{{ title }}</span>
    </h2>
  </div>-->
</ng-template>

<ng-template #appLinksSectionTemplate>
  <div class="btn-links" style="text-align: center;">
    <a class="btn btn-link" title="Click here if you have forgotten your password." (click)="resetPassword()">Reset Password</a>
  </div>
</ng-template>

<ng-template #additionalLoginInputTemplate>
  <div class="row">
    <div class="col-sm-12">
      <div class="input-group mb-3">
        <span class="input-group-text">
          <i class="fa fa-map-marker-alt"></i>
        </span>
        <input type="text" required minlength="2" class="form-control editable" name="userSite" (blur)="siteChange()" [(ngModel)]="siteCode"
          placeholder="Enter Site Code" autocomplete="sitecode">
      </div>
    </div>
  </div>
</ng-template>

<ng-template #resendEmailModal>
  <p>
    If your email confirmation link has expired or you did not receive the account confirmation email, you can request another one.
  </p>
  <label for="resendEmail" class="form-label">
    Enter the email address you registered with:
  </label>
  <input type="email" required name="resendEmail" class="form-control editable" [(ngModel)]="resendEmailAddress">
  <br>
</ng-template>
<div class="loginWrapper">
  <lib-login #loginView [appTitleTemplate]="appTitleTemplate"  [appLinksSectionTemplate]="appLinksSectionTemplate" [componentBackgroundColor]="'rgba(0,0,0,0)'" [additionalLoginInputsTemplate]="additionalLoginInputTemplate" [componentTextColor]="'#222'" [componentHeight]="300"></lib-login>
</div>
<div class="siteSelectWrapper" *ngIf="useSiteDropdown">
  <hr>
  <div class="col-5">
    <label for="siteSelection" class="form-label">
      <i class="fal fa-sitemap fa-lg me-1"></i>
      Please select a site to log in to:
    </label>
    <select name="siteSelection" id="siteSelection" class="form-control" [(ngModel)]="siteSelection" (ngModelChange)="updateSiteParam()">
      <option selected [value]="i + 1" *ngFor="let site of allSitesInfo; let i = index">
        {{ site.siteName }} (Site {{ i + 1 }})
      </option>
    </select>
  </div>
  <div class="col-5 text-center">
    <img class="h-50" *ngIf="selectedSitePath !== ''" (error)="selectedSitePath = 'assets/images/error.jpg'" [src]="selectedSitePath" alt="Site logo">
  </div>
</div>

<ng-template #prePasswordReset>
  <div>
    <p>Please enter your site </p>
    <input type="text" required minlength="2" class="form-control editable" name="userSite" (blur)="siteChange()" [(ngModel)]="siteCode"
          placeholder="Enter Site Code" autocomplete="sitecode">
  </div>
</ng-template>


<lib-reset-password-wizard *ngIf="resetPwdMode" #passwordWizard
  class="wizards" style="width: 40em;"
  [passwordScorerFn]="checkPasswordScore"
  [minimumPwdScore]="appMinimumPwdScore"
  [minimumPwdLength]="appMinimumPwdLength"
  [triggerEmailFn]="triggerEmailOnServer"
  [changePwdServerFn]="changePassword"
  [gotoPhase2]="phase2"
  [processResultSuccess]="resetPwdSuccess"
  [customFieldTemplate]="prePasswordResetModalTemplate"
  [validCustomField]="siteValid"
  (wizardCancelledEmitter)="cancelWizard()"
  (wizardCompletedEmitter)="cancelWizard()"
  >
  <span class="small">Reset your password</span>
</lib-reset-password-wizard>
